<template>
    <div class="box">
        <Header></Header>
        <!--联系我们-->
        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[0] : titleEng[0]}}</p>
                <p style="font-size: 16px;color: #3C3C3C;font-weight: bold;padding-top: 20px;">{{typefaces==1?'子拓国际贸易有限责任公司':'Zituo International Trade Co., Ltd'}}</p>
                <p style="font-size: 16px;color: #3C3C3C;padding-top: 5px;">https://www.zituobiz.com</p>
<!--                <p style="font-size: 14px;color: #494949;padding-top: 20px;">{{ typefaces==1?'内蒙古巴彦淖尔市乌拉特中旗海流图镇煤炭大厦14楼':'Floor  #14th, Coal Building, Hailiutu Town, Bayannaoer Urad Middle Banner, Inner Mongolia'}}</p>-->
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'北京办事处：010-87095922':'Beijing Office：010-87095922'}}</p>
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'乌兰巴托办事处：00976 75056688':'Head of Sales Business in Ulaanbaatar, Mongolia：00976 75056688'}}</p>
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'北京销售负责人：张静 18811444765':'Sales Manager in Beijing：Zhang Jing 18811444765'}}</p>
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'内蒙销售负责人：陈磊 15248887002':'Inner Mongolia Sales Manager：Chen Lei 15248887002'}}</p>
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'国内物流负责人：陈磊 15248887002':'Domestic Logistics Manager：Chen Lei 15248887002'}}</p>
                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'蒙古物流负责人：阿那日 00976 85155888':'Mongolian Logistics Manager: Anari 00976 85155888'}}</p>
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'中旗办事处：0478-7845777':'Inner Zhongqi Office：0478-7845777'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'包头办事处：0472-6221277':'Inner Baotou Office：0472-6221277'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'北京销售业务负责人：张静 18811444765':'Head of Sales Business in Beijing：Zhang Jing 18811444765'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'内蒙销售业务负责人：陈磊 15248887002':'Head of Sales Business in Inner Mongolia：Chen Lei 15248887002'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'蒙古国乌兰巴托办事处负责人：韩海明 00976 88666512':'Head of Sales Business in Ulaanbaatar, Mongolia：Hang Haiming 00976 88666512'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'国际运输业务负责人：陈会青 18247897796':'Head of International Transportation Business：Chen Huiqing 18247897796'}}</p>-->
<!--                <p style="font-size: 14px;color: #494949;padding-top: 10px;">{{typefaces==1?'国内运输业务负责人：董玉涛 15248887288':'Head of Domestic Transportation Business：Dong Yutao 15248887288'}}</p>-->
            </div>

            <div class="nav" style="padding: 0 10px;margin-top: -90px;">
              <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[2] : titleEng[2]}}</p>
              <!--<img v-if="typefaces==1" style="width: 100%;height: auto;margin-top:15px;" src="../../../img/rc1.png" alt="">-->
              <!--<img v-if="typefaces==2" style="width: 100%;height: auto;margin-top:15px;" src="../../../img/rc2.png" alt="">-->
            </div>

          <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'ContactUs',
	components: {
		Header,
        Footer
	},
  computed: {
    aaa() {
      return this.$root.TYPEFACE;
    }
  },
  watch:{
    aaa(type) {
      this.typefaces = type;
    },
  },
	data () {
		return {
      typefaces: 1,
      typeFacesNumber: 0,
            banner: {},
      titleName: ['联系我们','人才招聘'],
      titleEng: ['Contact Us','Talents'],
		}
	},

	mounted() {
    this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.getData();
	},

	methods: {
    fatherMethod(type){
      this.typefaces = type;
      this.typeFacesNumber = type;
    },
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 16
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/ContactUs/contactUs.vue